const GPI = {
	banner: [{
		tips:'什么是GPI？',
		title:'GPI',
		content:'GPI是基于ISO14025 III型环境声明的原则和程序建立的管理规则，是中国有色金属行业EPD平台的运作基础。',
		img:require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png')
	}],
	dwon_CN:'中文版GPI下载',
	dwon_EN:'英文版GPI下载',
}

export default GPI